import { forwardRef, type CSSProperties, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../cn';

/** Общее у тега и квадратика: высота 18 px, углы 4 px, заливка 16 % и текст 85 % цвета типа */
const TAG =
  'nd:inline-flex nd:h-4.5 nd:shrink-0 nd:items-center nd:rounded-[0.25rem] nd:bg-[color-mix(in_oklab,var(--t)_16%,transparent)] nd:text-[0.6875rem] nd:leading-none nd:font-medium nd:whitespace-nowrap nd:text-[color-mix(in_oklab,var(--t)_85%,var(--foreground))]';

/**
 * Тег (тип файла, тип сессии; в строке списка — подстатус, заметка, срок): квадратные углы 4 px и заливка 16 % цвета
 * (концепт file-cards 3.2, для строки списка — compact-rows 1.2.2.1).
 */
export const TypeTag = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement> & { color: string; children: ReactNode }>(function TypeTag(
  { color, className, style, children, ...props },
  ref
) {
  return (
    // ...props — от Tooltip (триггер): обработчики наведения и data-state
    <span ref={ref} {...props} style={{ ...style, '--t': color } as CSSProperties} className={cn(TAG, 'nd:px-1.5', className)}>
      {children}
    </span>
  );
});

/**
 * Тот же тег в формате 1:1 — 18×18 с первой буквой типа (концепт type-swatch, 1.2): знак типа в меню «Тип файла».
 * Без буквы — пустой квадрат той же заливки («Без типа»). Подпись типа стоит рядом, поэтому квадрат скрыт от диктора.
 */
export function TypeSwatch({
  color,
  letter,
  className,
  style,
  ...props
}: Omit<HTMLAttributes<HTMLSpanElement>, 'children' | 'style'> & {
  color: string;
  letter?: string;
  /** Свои CSS-переменные квадратика (например, --f заливки этапа) */
  style?: Record<`--${string}`, string>;
  [data: `data-${string}`]: unknown;
}) {
  return (
    <span
      aria-hidden="true"
      {...props}
      style={{ ...style, '--t': color } as CSSProperties}
      className={cn(TAG, 'nd:w-4.5 nd:justify-center', className)}
    >
      {letter}
    </span>
  );
}
